function roleFromLocation(location) {
  const roleMatch = location.search.match(/role=(\d+)/);
  return roleMatch && Number(roleMatch[1]);
}

export default roleFromLocation;
